// Shared framer-motion variants used across every section.
//
// The motion language matches the dell-1996 chrome: hard-edged and mechanical,
// not soft and floaty. Things WIPE, SNAP and STAMP into place rather than
// drifting. Everything stays on transform / opacity / clip-path so it composites
// on the GPU, and <MotionConfig reducedMotion="user"> neutralises the lot for
// anyone who asks for reduced motion.

const EASE = [0.25, 0.1, 0.25, 1];
// Snappy decelerate — the "stamped down" feel. Fast out of the gate, hard stop.
const SNAP = [0.16, 1, 0.3, 1];

// Reveal config reused on whileInView wrappers.
export const viewport = { once: true, margin: "-70px" };

export const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: SNAP } },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.6, ease: EASE } },
};

// Text wipes up from behind a mask. The parent must clip (see MaskLine below).
export const revealLine = {
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration: 0.65, ease: SNAP } },
};

// A window "opening": the body unrolls downward from its title bar.
export const wipeDown = {
  hidden: { opacity: 0, clipPath: "inset(0 0 100% 0)" },
  show: {
    opacity: 1,
    clipPath: "inset(0 0 0% 0)",
    transition: { duration: 0.55, ease: SNAP },
  },
};

// Chips / badges punching in. Slight overshoot reads as mechanical, not bouncy.
export const stampIn = {
  hidden: { opacity: 0, scale: 0.82 },
  show: {
    opacity: 1,
    scale: 1,
    transition: { type: "spring", stiffness: 620, damping: 26, mass: 0.5 },
  },
};

// Award seals landing on the page.
export const sealIn = {
  hidden: { opacity: 0, scale: 0.5 },
  show: {
    opacity: 1,
    scale: 1,
    transition: { type: "spring", stiffness: 460, damping: 20, mass: 0.6 },
  },
};

// Slides in from a side — used for the alternating campsite dossiers.
export const slideFrom = (dir = "right", distance = 40) => ({
  hidden: { opacity: 0, x: dir === "left" ? -distance : distance },
  show: { opacity: 1, x: 0, transition: { duration: 0.55, ease: SNAP } },
});

// Container that staggers its children. Call as a factory for custom timing.
export const staggerContainer = (stagger = 0.08, delay = 0) => ({
  hidden: {},
  show: { transition: { staggerChildren: stagger, delayChildren: delay } },
});

export { EASE, SNAP };
